import React from "react";

import ContractHoldersHeaderSearch from "../../shared/HeaderSearch.jsx";
import RowWrapper from "../../shared/bootstrap/RowWrapper.jsx";

export default function ContractHoldersHeaderOptions({ searchType, setSearchType, searchValue, setSearchValue }) {
  return (
    <RowWrapper>
      <div className="contract-holders-options col-sm-7" title="help text">
        <ul>
          <li>Select the Company Name to display the detailed information page for the specified Contract Holder.</li>
          <li>
            Select the column heading 'Company' or 'Contract' to sort the table by that column - select it again to
            reverse the sort.
          </li>
          <li>Select a group below to only show Contract Holders within the specified group.</li>
          <li>
            Enter text in the search field to search within the table. Select from the radio buttons above the field to
            restrict your search. Select clear search to clear the search field.
          </li>
        </ul>
      </div>
      <ContractHoldersHeaderSearch
        searchType={searchType}
        setSearchType={setSearchType}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
      />
    </RowWrapper>
  );
}
